import React from 'react';
import { Grid2, Stack, Typography } from '@mui/material';
import { ReactComponent as NoSearchResults } from 'assets/images/EmptyState/NoSearchResults.svg';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { RESOURCE_LAYOUT_GRID_COLUMNS } from 'themes/constants';

export const ResourceSearchEmptyState = () => {
  const { translation } = useTranslationContext();

  return (
    <Grid2 size={RESOURCE_LAYOUT_GRID_COLUMNS}>
      <Stack alignItems="center" spacing={2} sx={{ py: 6 }}>
        <NoSearchResults role="img" aria-label="No search results" width={240} height={250} />
        <Typography
          variant="headline"
          textAlign="center"
          fontWeight={500}
          sx={{ color: (theme) => theme.palette.primary.main }}
        >
          {translation('search_results_empty_title')}
        </Typography>
        <Typography
          variant="callout"
          textAlign="center"
          sx={{ color: (theme) => theme.palette.grey[800] }}
        >
          {translation('search_results_empty_body')}
        </Typography>
      </Stack>
    </Grid2>
  );
};

ResourceSearchEmptyState.displayName = 'ResourceSearchEmptyState';
